// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_4713","list":"_17349"};